(() => {
  if (customElements.get('rp-card-slider')) return;
  customElements.define('rp-card-slider', class extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('.rp-card-grid');
      this.bar = this.querySelector('[role="progressbar"]');
      if (!this.grid || !this.bar) return;
      this.abort = new AbortController();
      if (this.hasAttribute('data-dots')) {
        this.dots = document.createElement('div');
        this.dots.className = 'rp-card-dots';
        this.dots.setAttribute('role', 'group');
        this.dots.setAttribute('aria-label', 'Category slides');
        this.bar.after(this.dots);
      }
      const schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); });
      };
      this.grid.addEventListener('scroll', schedule, { passive: true, signal: this.abort.signal });
      this.addEventListener('shopify:block:select', event => {
        if (matchMedia('(max-width:749px)').matches) event.target.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }, { signal: this.abort.signal });
      this.resize = new ResizeObserver(schedule);
      this.resize.observe(this.grid);
      this.update();
    }
    update() {
      const { clientWidth, scrollWidth, scrollLeft } = this.grid;
      const ratio = Math.min(1, clientWidth / Math.max(1, scrollWidth));
      const position = Math.min(1, Math.abs(scrollLeft) / Math.max(1, scrollWidth - clientWidth));
      if (this.dots) {
        this.bar.hidden = true;
        this.dots.hidden = ratio >= .999;
        const cards = this.grid.children;
        const step = cards.length > 1 ? (cards[1].offsetLeft - cards[0].offsetLeft) * 2 : clientWidth;
        const end = Math.max(0, scrollWidth - clientWidth);
        this.positions = [0];
        if (this.hasAttribute('data-pages')) {
          this.positions = [...cards].map(card => Math.min(end, card.offsetLeft - cards[0].offsetLeft));
        } else if (step > 0) for (let x = step; x < end - 1; x += step) this.positions.push(x);
        if (!this.hasAttribute('data-pages') && end > 1) this.positions.push(end);
        if (this.dots.children.length !== this.positions.length) {
          this.dots.replaceChildren(...this.positions.map((_, index) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.setAttribute('aria-label', `Go to category slide ${index + 1}`);
            button.addEventListener('click', () => this.grid.scrollTo({left: this.positions[index], behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'}));
            return button;
          }));
        }
        const active = this.positions.reduce((best, x, index) => Math.abs(x - Math.abs(scrollLeft)) < Math.abs(this.positions[best] - Math.abs(scrollLeft)) ? index : best, 0);
        [...this.dots.children].forEach((button, index) => button.setAttribute('aria-current', String(index === active)));
        return;
      }
      this.bar.hidden = ratio >= .999;
      this.bar.setAttribute('aria-valuenow', Math.round(position * 100));
      const thumb = this.bar.firstElementChild;
      thumb.style.width = `${ratio * 100}%`;
      thumb.style.transform = `translateX(${position * (1 - ratio) / ratio * 100}%)`;
    }
    disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); cancelAnimationFrame(this.frame); this.dots?.remove(); }
  });
})();
